import { Model } from "./model";

export class CommReceipt extends Model {

  constructor(
    public id?: number,
    public commSendId?: number,
    public status: string = null,
    public rejectReason: string = null,
    public mandrillId: string = null,
    public recipientName: string = null,
    public recipientAddress: string = null,

    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super(); }

  static clone(obj: any) {
    const o = new this()

    if (obj.id) { o.id = obj.id }
    if (obj.commSendId) { o.commSendId = obj.commSendId }
    if (obj.status) { o.status = obj.status }
    if (obj.rejectReason) { o.rejectReason = obj.rejectReason }
    if (obj.mandrillId) { o.mandrillId = obj.mandrillId }
    if (obj.recipientName) { o.recipientName = obj.recipientName }
    if (obj.recipientAddress) { o.recipientAddress = obj.recipientAddress }

    if (obj.updatedAt) { o.updatedAt = new Date(obj.updatedAt) }
    if (obj.createdAt) { o.createdAt = new Date(obj.createdAt) }

    return o
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/comm-receipt.ts